import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './ListItem.css'

class ListItem extends Component {
  render () {
    let {children, ...otherAttributes} = this.props

    return (
      <li className={`hw-list-item ${styles.list_item}`} {...otherAttributes}>{children}</li>
    )
  }
}

ListItem.propTypes = {
  children: PropTypes.node
}

export default ListItem



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/ListItem/index.js